module.exports = __webpack_public_path__ + "img/PADS_NO_MG__NOtag_PMS2995-520x225.fef37f70.png";